import { render, staticRenderFns } from "./ChangeClientType.vue?vue&type=template&id=0fa4abe6&"
import script from "./ChangeClientType.vue?vue&type=script&lang=js&"
export * from "./ChangeClientType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports